module.exports = __webpack_public_path__ + "static/img/center_aut2_img.7016330.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mine/center_aut2_img.png
// module id = hyIn
// module chunks = 1